import MicroEvent from '../../assets/js/microevent';

class FilterEvent extends MicroEvent {
	componentDidMount() {
		this.eventName = "";

		let s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
		let length = s.length;
		let n = 5;

		while (n--) {
			this.eventName += s.charAt(Math.floor(Math.random() * length));
		}
	}

	bind(cb) {
		this._bind(this.eventName, cb);
	}

	unbind(cb) {
		this._unbind(this.eventName, cb);
	}

	trigger(params) {
		this._trigger(this.eventName, params);
	}

}

export default new FilterEvent();



// WEBPACK FOOTER //
// ./src/components/filter/filter.event.js